<script>
import { saveUser } from '@/api/user.js';
import constants from '@/constants';

export default {
    computed: {
        isSaveEdit() {
            return this.$store.getters.IS_SAVE_EDIT_DATA;
        },
        userEditData() {
            return this.$store.getters.USER_EDIT_DATA;
        },
    },
    methods: {
        async save() {
            const response = await saveUser(
                this.userEditData.id,
                this.userEditData.name,
                this.userEditData.company
            );
            if (response) {
                this.$store.commit('USER_SET_DATA', {
                    id: this.userEditData.id,
                    name: this.userEditData.name,
                    company: this.userEditData.company,
                });
                this.$store.dispatch('loadUserDetails');
            }
        },
        async closeEdit() {
            this.$store.commit('IS_SHOW_USER_EDIT', false);

            // Return to previous context (analytics vs user management)
            if (this.$route.name === 'userAnalyticsWithUser') {
                this.$router.push({
                    name: constants.ROUTER_NAME.USERANALYTICS,
                });
            } else {
                this.$router.push({ name: constants.ROUTER_NAME.USEREDIT });
            }
        },
    },
};
</script>

<template>
    <button
        :disabled="isSaveEdit === false"
        class="button_blue_100"
        @click="save"
    >
        Save
    </button>
    <button class="button_blue_100 mr_10 close_button" @click="closeEdit">
        Close
    </button>
</template>
